import * as actionTypes from './actionTypes';
import { LoadableData } from './state';
import { ProductSpecs } from '../services/specs';
import { Offer } from '../services/pricing';
import { ProductShape } from '../services/products';
import { Project } from '../services/project';

export interface State {
  mpId?: string;
  projectId?: string;
  loadableProject: LoadableData<Project>;
  loadableProductShapes: LoadableData<ProductShape[]>;
  loadableBaseOffer: LoadableData<Offer>;
  loadablePricingContext: LoadableData<string>;
  loadableUpsellPriceBySKU: LoadableData<{ [sku: string]: string }>;
  loadableProductSpecsBySKU: LoadableData<{ [sku: string]: ProductSpecs }>;
}

export const initialState: State = {
  mpId: undefined,
  projectId: undefined,
  loadableProject: { loading: false, data: undefined, error: undefined },
  loadableProductShapes: { loading: true, data: undefined, error: undefined },
  loadableBaseOffer: { loading: true, data: undefined, error: undefined },
  loadablePricingContext: { loading: true, data: undefined, error: undefined },
  loadableUpsellPriceBySKU: { loading: true, data: undefined, error: undefined },
  loadableProductSpecsBySKU: { loading: true, data: undefined, error: undefined },
};

export default (state = initialState, action: any): State => {
  switch (action.type) {
    case actionTypes.SET_MP_ID:
      return {
        ...state,
        mpId: action.mpId,
      };
    case actionTypes.SET_PROJECT_ID:
      return {
        ...state,
        projectId: action.projectId,
        // when we set a new projectId, set the project to "loading"
        loadableProject: { loading: true, data: undefined, error: undefined },
      };
    case actionTypes.SET_LOADABLE_PROJECT:
      return {
        ...state,
        loadableProject: action.loadableProject,
      };
    case actionTypes.SET_LOADABLE_PRODUCT_SHAPES:
      return {
        ...state,
        loadableProductShapes: action.loadableProductShapes,
      };
    case actionTypes.SET_LOADABLE_BASE_OFFER:
      return {
        ...state,
        loadableBaseOffer: action.loadableBaseOffer,
      };
    case actionTypes.SET_LOADABLE_PRICING_CONTEXT:
      return {
        ...state,
        loadablePricingContext: action.loadablePricingContext,
      };
    case actionTypes.SET_LOADABLE_UPSELL_PRICE_BY_SKU:
      return {
        ...state,
        loadableUpsellPriceBySKU: action.loadableUpsellPriceBySKU,
      };
    case actionTypes.SET_LOADABLE_PRODUCT_SPECS_BY_SKU:
      return {
        ...state,
        loadableProductSpecsBySKU: action.loadableProductSpecsBySKU,
      };
    default:
      return state;
  }
};
